import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CompanyService } from '../../auth/_services/company.service';
import { API_COMPANY_URL, API_GROUP_URL, API_USERS_URL } from '../../connection.data';
import { filter, switchMap, take } from 'rxjs/operators';
@Injectable()
export class CommonFieldsInterceptor implements HttpInterceptor {
    constructor(public companyService: CompanyService) {}
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        
        // console.log("intercept company:");console.dir(company);
        // console.log(`method: ${req.method}`);
        // console.dir(req);
        const routesWithoutCompany = [
            `${API_USERS_URL}/login`,
            `${API_USERS_URL}/token-login`,
            `${API_USERS_URL}/toggleUsers`,
            `${API_COMPANY_URL}/all`,
            `${API_GROUP_URL}/all`
        ]

        if(routesWithoutCompany.includes(req.url)){
            return next.handle(req);
        }else{
            return this.companyService.companyLoaded$.pipe(
                filter(loaded=>loaded==true),
                take(1),
                switchMap(()=>{
                    // console.log("req antes");console.dir(req);
                    const company = this.companyService.getCurrentCompany();
                    if(req.method == 'POST' || req.method=="PUT"){
                        if(req.body instanceof FormData){
                            req.body.append('company_id', company.id);
                        }else{
                            req = req.clone({body: Object.assign({company_id: company.id}, req.body)});
                        }                        
                    }
                    if(req.method == 'GET')
                        req = req.clone({
                            params: req.params.set('company_id', `${company.id}`)
                        });
                    // console.log("req despues"); console.dir(req);
                    return next.handle(req);
                })
            );
        }        
    }
}

// export class AuthInterceptor implements HttpInterceptor {
//     intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//         const token = localStorage.getItem('auth_token');
//         if (!token) {
//             return next.handle(req);
//         }
//         const headers = req.clone({
//             headers: req.headers.set('Authorization', `Bearer ${token}`)
//         });
//         return next.handle(headers);
//     }
// }